export default __webpack_public_path__ + "static/media/SWT1980.34I-41956_-25160_0.f821c341.jpg";